const topics = [
  { id: 1, label: '古装玄幻', count: '3.2万讨论', hot: true },
  { id: 2, label: '暑期档追剧', count: '2.8万讨论', hot: true },
  { id: 3, label: '国产动漫崛起', count: '2.5万讨论', hot: true },
  { id: 4, label: '韩剧推荐', count: '1.9万讨论', hot: false },
  { id: 5, label: '悬疑烧脑', count: '1.7万讨论', hot: false },
  { id: 6, label: '院线大片', count: '1.5万讨论', hot: false },
  { id: 7, label: '经典重刷', count: '1.3万讨论', hot: false },
  { id: 8, label: 'CP感爆棚', count: '1.1万讨论', hot: false },
  { id: 9, label: '剧荒拯救', count: '9800讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            大家都在讨论什么
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href={`#topic-${topic.id}`}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200 hover:bg-background-200/70'
              }`}
            >
              <span
                className={`text-sm font-medium ${
                  topic.hot ? 'text-primary-700' : 'text-foreground-700'
                }`}
              >
                #{topic.label}
              </span>
              <span className="text-xs text-foreground-500">{topic.count}</span>
              {topic.hot && (
                <span className="flex items-center gap-0.5 text-xs text-accent-600">
                  <i className="ri-fire-line"></i>热
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}